import { config as configDefaults } from "./defaultConfig";
import { WebviewerConfig } from "mapview-gui-utils/src/config/WebviewerConfig";
import { ref } from 'vue';

class WebviewerConfigNasim extends WebviewerConfig {
  
  constructor(configDefaults) {
    super(configDefaults);
    this.config = ref(this.config);
  }

  setConfig(config) {
    if (this.initialized === true) {
      return;
    }
    this.initialized = true;
    for (let key in config) {
      this.config.value[key] = config[key];
    }
  }


  getModellCommentTagSet(){
    return this.config.value.modellCommentTagSet;
  }

  getBackgroundLayers() {
    if (this.config.value.backgroundLayers === undefined) {
      return [];
    }
    return this.config.value.backgroundLayers;
  }

  getDefaultBackgroundLayerIndex() {
    return this.config.value.defaultBackgroundLayerIndex;
  }

  getadditionalLayers() {
    return this.config.value.additionalLayers;
  }
}


export let config = new WebviewerConfigNasim(configDefaults);